/** 실시간 피드백 메뉴·신청 카테고리 노출 여부 (기본: 비공개, URL로만 접근) */
export function isRealtimeFeedbackPublicEnabled(): boolean {
  return process.env.NEXT_PUBLIC_REALTIME_FEEDBACK_PUBLIC === "true";
}
